/** アプリケーション内で使用するメソッド名称 */
export const SET_ERROR_DETAIL = 'SET_ERROR_DETAIL'
export const UPD_ERROR_DETAIL = 'UPD_ERROR_DETAIL'
export const UPD_TOP_PANEL = 'UPD_TOP_PANEL'
export const UPD_TOP_PANEL2 = 'UPD_TOP_PANEL2'
export const UPD_TOP_PANEL3 = 'UPD_TOP_PANEL3'
export const UPD_TOP_PANEL4 = 'UPD_TOP_PANEL4'
export const UPD_TOP_PANEL5 = 'UPD_TOP_PANEL5'
export const UPD_HELP_POPUP = 'UPD_HELP_POPUP'
